import { z } from "zod";

export enum EExaLightModulationMode {
  STOP = "STOP",
  FROST_GUARD = "FROST_GUARD",
  ECO = "ECO",
  COMFORT = "COMFORT",
  COMFORT_PASS_THROUGH = "COMFORT_PASS_THROUGH",
  ON = "ON",
  TEMPERATURE = "TEMPERATURE",
  FAILED_BACKEND = "FAILED_BACKEND",
  COMFORT_2 = "COMFORT_2",
  COMFORT_1 = "COMFORT_1",
  NO_MODULATION = "NO_MODULATION",
}

export enum EExaLightModulationOrigin {
  UNKNOWN = "UNKNOWN",
  PRODUCTION = "PRODUCTION",
  SSY = "SSY",
  SUBSCRIBER_TEMPERATURE = "SUBSCRIBER_TEMPERATURE",
  SUBSCRIBER_ON_OFF = "SUBSCRIBER_ON_OFF",
  SUBSCRIBER_ABSENCE = "SUBSCRIBER_ABSENCE",
  SUBSCRIBER_HEATER = "SUBSCRIBER_HEATER",
  FAILED_BACKEND = "FAILED_BACKEND",
}

export enum EExaLightRelayState {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  IS_NOT_A_RELAY = "IS_NOT_A_RELAY",
  UNKNOWN = "UNKNOWN",
}

export enum EExaLightIsAutoTest {
  TRUE = "TRUE",
  FALSE = "FALSE",
  NO_INFO = "NO_INFO",
}

export const odityExtendedLocalModulationDtoSchema = z.object({
  isWeekly: z.boolean(),
  mode: z.nativeEnum(EExaLightModulationMode),
  range: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
  }),
});

export const odityExtendedPowerMeasure = z.object({
  power: z.number().nullable(),
  dateTime: z.coerce.date(),
});

export const odityExtendedModulatorExactDtoSchema = z.object({
  localModulations: z.array(odityExtendedLocalModulationDtoSchema),
  activePowerMeasures: z.array(odityExtendedPowerMeasure),
});

export const controlMonitoringLocalModulationDtoSchema = z.object({
  dateEnd: z.coerce.date(),
  dateStart: z.coerce.date(),
  modulationMode: z.nativeEnum(EExaLightModulationMode),
  modulationOrigin: z.nativeEnum(EExaLightModulationOrigin),
});

export const controlMonitoringLiveVXDiagnosticDtoSchema = z.object({
  isAutoTesting: z.nativeEnum(EExaLightIsAutoTest),
  relayState: z.nativeEnum(EExaLightRelayState),
  wireCommandMode: z.nativeEnum(EExaLightModulationMode),
});

export const odityExtendedModulatorControlMonitoringDtoSchema = z.object({
  localModulations: z.array(controlMonitoringLocalModulationDtoSchema),
  liveVXDiagnostic: controlMonitoringLiveVXDiagnosticDtoSchema,
  activePowerMeasures: z.array(odityExtendedPowerMeasure),
});

export type TOdityExtendedLocalModulationDto = z.infer<typeof odityExtendedLocalModulationDtoSchema>;
export type TOdityExtendedModulatorExactDto = z.infer<typeof odityExtendedModulatorExactDtoSchema>;
export type TOdityExtendedModulatorControlMonitoringDtoSchema = z.infer<
  typeof odityExtendedModulatorControlMonitoringDtoSchema
>;
export type TControlMonitoringLocalModulationDtoSchema = z.infer<typeof controlMonitoringLocalModulationDtoSchema>;
export type TControlMonitoringLiveVXDiagnosticDtoSchema = z.infer<typeof controlMonitoringLiveVXDiagnosticDtoSchema>;
